export const API_BASE = import.meta.env.VITE_API_URL || "/api";

export async function apiFetch(
  path: string,
  options: RequestInit & { isFormData?: boolean } = {}
) {
  const token = localStorage.getItem("token");
  const org = localStorage.getItem('organization');

  // Nur Content-Type setzen, wenn Body kein FormData ist
  const isFormData = options.isFormData || options.body instanceof FormData;
  
  const headers: HeadersInit = {
    ...(!isFormData ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(org ? { 'X-Org': org } : {}),
    ...options.headers,
  };

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  // 🔒 TOKEN ABGELAUFEN ODER UNGÜLTIG
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/";
    throw new Error("Nicht autorisiert");
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({
      message: "API Fehler",
    }));
    throw error;
  }

  // Prüfe ob die Antwort überhaupt Inhalt hat
  const contentType = response.headers.get("content-type");
  const contentLength = response.headers.get("content-length");
  
  // Wenn kein Content-Type oder Content-Length 0, dann kein JSON parsen
  if (contentLength === "0" || response.status === 204) {
    return null;
  }
  
  // Wenn Content-Type nicht JSON ist, versuche trotzdem zu parsen (Fallback)
  if (!contentType?.includes("application/json")) {
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch {
      return null;
    }
  }

  return response.json();
}
